module.exports = __webpack_public_path__ + "static/img/important5.1ea29bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/important5.png
// module id = l82j
// module chunks = 1